import React from 'react';
import ReactDOM from 'react-dom';

import { ContextualHelpModal } from 'react-viiad-core-ui/src/Components/Core/ContextualHelpModal';
import { StagedModal } from 'react-viiad-core-ui/src/Components/Core/StagedModal';

window.React = React;
window.ReactDOM = ReactDOM;
window.ContextualHelpModal = ContextualHelpModal;
window.StagedModal = StagedModal;